import PricingSocketService from "../pricing_socket_service";
import io from "socket.io-client";
import { API_BASE_URL } from "../../../../core/constants/app_constants";

class PricingSocketServiceImpl extends PricingSocketService {
  static #instance = null; // Private static instance
  pricingSocket = null;
  onConnected = null;
  onDisconnected = null;
  onPaymentEvent = null;
  onError = null;
  constructor() {
    if (PricingSocketServiceImpl.#instance) {
      return PricingSocketServiceImpl.#instance; // Return existing instance
    }
    super();
    PricingSocketServiceImpl.#instance = this; // Store instance
  }

  connect({ onConnected, onDisconnected, onPaymentEvent, onError }) {
    try {
      this.onConnected = onConnected;
      this.onDisconnected = onDisconnected;
      this.onPaymentEvent = onPaymentEvent;
      this.onError = onError;
      if (this.pricingSocket) {
        console.log("Pricing socket already exists");
        return;
      }
      console.log("PricingSocketServiceImpl connect");
      this.pricingSocket = io(`${API_BASE_URL}/payment`, {
        path: "/socket.io",
      });
      this.pricingSocket.on("connect", () => {
        console.log("Connected to /payment namespace with id:", this.pricingSocket.id);
        if (this.onConnected) {
          this.onConnected(this.pricingSocket.id);
        }
      });
      this.pricingSocket.on("paymentEvent", (data) => {
        console.log("Payment event received:", data);
        if (this.onPaymentEvent) {
          this.onPaymentEvent(data);
        }
      });
      this.pricingSocket.on("disconnect", () => {
        console.log("Disconnected from /payment namespace");
      });
    } catch (error) {
      console.error("PricingSocketServiceImpl connect error:", error);
      this.onError("Something went wrong");
      this.disconnect();
    }
  }

  disconnect() {
    console.log("PricingSocketServiceImpl disconnect");
    if (this.pricingSocket) {
      this.pricingSocket.disconnect();
      this.pricingSocket = null;
    }
    if (this.onDisconnected) {
      this.onDisconnected();
    }
  }

  getSocketId() {
    return this.pricingSocket?.id || null;
  }
}

export default PricingSocketServiceImpl;
